import type { UseQueryOptions } from '@tanstack/react-query';
import type { ShopifyTheme } from '~/modules/shopify/types';

import { useQuery } from '@tanstack/react-query';
import { fetchFromAPI } from '~/api/utils';

const queryKey = 'shopifyTheme';
export const useQueryShopifyTheme = <TError = Error, TData = ShopifyTheme>(
  variables?: undefined,
  options?: UseQueryOptions<ShopifyTheme, TError, TData>,
) => {
  return useQuery<ShopifyTheme, TError, TData>({
    queryKey: [queryKey, variables],
    queryFn: () => fetchFromAPI('/api/shopify/theme', { method: 'GET' }),
    ...options,
  });
};
useQueryShopifyTheme.getKey = (variables: undefined) => [queryKey, variables];
